import * as DKFDS from 'dkfds';
import $ from 'jquery';

function shareContact() {
    $('#shareAddressBookContactLoading').show();
    $('form').append("<input type='hidden' name='share' value='1'>").submit();
}

function onShowModal($modal) {
    const noContacts = $('input:checked[name=selectedContacts]').length;
    const contactsText = noContacts === 1 ? ' kontakt' : ' kontakter';
    $('#shareAddressBookContactText').html(
        `Du er i gang med at dele ${noContacts}${contactsText}.
        Du deler kontakterne med de øvrige brugere i virksomheden.
        Når kontakterne er delt kan handlingen ikke fortrydes.`
    );
    $('#shareAddressBookContactModalOK').one('click', shareContact);
}

function onClick() {
    const noContacts = $('input:checked[name=selectedContacts]').length;
    if (noContacts === 0) {
        new DKFDS.Toast(document.getElementById('shareAddressBookContactError')).show();
    }
    else {
        new DKFDS.Modal(document.getElementById('shareAddressBookContactModal')).show();
    }
}

$(() => {
    const $modal = $('#shareAddressBookContactModal');

    $('#btnShareAddressBookContact').on('click', onClick);
    $modal.get(0).addEventListener('fds.modal.shown', () => onShowModal($modal))
});
